export default {"src":"/uk/_next/static/media/discoverIconGrey.f0571065.svg","height":20,"width":20,"blurWidth":0,"blurHeight":0};